"use client"

import { Wallet } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WalletIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WalletIcon = component(Icon)({ as: Wallet })
